module.exports = __webpack_public_path__ + "media/images/download-09bab4f37683fdb0b5721b776bedf3c4.svg";